(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["play-like-a-boss-section"] && !window.DesignMode) return;
  try {
    
    const BOSS_SECTION = document.getElementById("bossSectionWrapper");

  if (!BOSS_SECTION) return;

  const images = BOSS_SECTION.querySelectorAll(".img-block");
  const togglers = BOSS_SECTION.querySelectorAll(
    ".like-a-boss-section__list-item a"
  );

  togglers.forEach((toggler) => {
    toggler.addEventListener("click", toggleImage);
  });
  function toggleImage(e) {
    e.preventDefault();

    images.forEach((image) => {
      image.classList.remove("active");
    });

    togglers.forEach((toggle) => {
      toggle.classList.remove("active");
    });

    e.target.classList.add("active");

    images.forEach((image) => {
      if (image.classList.contains(e.target.dataset.key)) {
        image.classList.add("active");
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-main"] && !window.DesignMode) return;
  try {
    
      let swiper = new Swiper(".mySwiper", {
        loop: true,
        spaceBetween: 10,
        slidesPerView: 4,
        freeMode: true,
        watchSlidesProgress: true,
      });
      let swiper2 = new Swiper(".mySwiper2", {
        loop: true,
        spaceBetween: 10,
        navigation: {
          nextEl: ".gallery .swiper-button-next",
          prevEl: ".gallery .swiper-button-prev",
        },
        thumbs: {
          swiper: swiper,
        },
      });

    let swiperSlides = document.querySelectorAll(".gallery-slider .swiper-slide");
    let videos = document.querySelectorAll(".gallery-slider iframe");
    let sourceAttributes = [];
    if (videos) {
      videos.forEach((video) => sourceAttributes.push(video.getAttribute("src")));
      videos.forEach((video) => video.src = video.src.replace('autoplay=1','autoplay=0') );
    }
    function updateSlideVideos(params) {
      videos.forEach((video, index) => {
        video.src = "";
        console.log(sourceAttributes[index])
        video.src = sourceAttributes[index].replace('autoplay=1','autoplay=0');
      });
    }
  let flag = 1;
  swiper2.on('realIndexChange',function () {
    let currentActiveiframe = document.querySelector(".gallery-slider .swiper-slide-active iframe");
    if(currentActiveiframe ) {
      flag == 0;
      updateSlideVideos();
    }
    if(!currentActiveiframe){
      flag == 0 ? updateSlideVideos() : flag == 1;
    }
  });
    const productDescriptionShort = document.getElementById(
    "productDescriptionShort"
  );
  const productDescriptionFull = document.getElementById(
    "productDescriptionFull"
  );

  if (!productDescriptionShort && !productDescriptionFull) return;

  const SHOW_MORE_BTN = document.getElementById("showMoreBtn");

  SHOW_MORE_BTN.addEventListener("click", showMore);

  function showMore(e) {
    if (productDescriptionShort.classList.contains("active")) {
      productDescriptionFull.classList.add("active");
      productDescriptionShort.classList.remove("active");
      SHOW_MORE_BTN.innerText = "Hide";
      return;
    }
    if (productDescriptionFull.classList.contains("active")) {
      productDescriptionFull.classList.remove("active");
      productDescriptionShort.classList.add("active");
      SHOW_MORE_BTN.innerText = "Show more";
      return;
    }
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recomendations"] && !window.DesignMode) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            if (html.querySelector('.grid__item')) {
              this.classList.add('product-recommendations--loaded');
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();
})();
